import { FC } from 'react'
import styled from 'styled-components'
import useJobCategoryStore from '../store/store.jobCategory'

interface IFResetButtonProps {
  className?: string
}

const ResetButton: FC<IFResetButtonProps> = ({ className }) => {
  const resetState = useJobCategoryStore((state) => state.resetState)

  const handleReset = () => {
    resetState()
  }

  return (
    <StyledButton
      aria-label="초기화"
      type="button"
      onClick={handleReset}
      className={className}
    >
      <img src="/static/images/activity/reset.svg" />
      <span className="reset-label">초기화</span>
    </StyledButton>
  )
}

export default ResetButton

const StyledButton = styled.button`
  display: flex;
  align-items: center;
  color: ${(props) => props.theme.color.text_1};
  font-size: 12px;
  font-weight: 700;
  opacity: 1;
  border: none;
  background-color: transparent;
  transition: all 0.1s ease-in-out;

  :hover {
    cursor: pointer;
    opacity: 0.9;
  }

  .reset-label {
    margin-left: 4px;
  }
`
